import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ShoppingCart } from 'lucide-react';

export default function ProdAltsModal({ open, onClose, product, offers, loading, onAddToCart }) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-4xl max-h-[80vh] flex flex-col gap-0 p-0 overflow-hidden">
        <div className="px-6 pt-5 pb-4 border-b border-gray-100 flex-shrink-0">
          <DialogHeader>
            <DialogTitle className="text-base font-bold text-gray-900">
              Альтернативы от других поставщиков
            </DialogTitle>
          </DialogHeader>
          {product && (
            <p className="text-xs text-gray-400 mt-1 truncate">
              {product.brand ? `${product.brand} · ` : ''}{product.name}
            </p>
          )}
        </div>
        <div className="flex-1 overflow-y-auto min-h-0">
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
            </div>
          ) : offers.length === 0 ? (
            <p className="text-sm text-gray-500 px-6 py-8 text-center">
              Нет альтернативных предложений от других поставщиков
            </p>
          ) : (
            <table className="w-full text-sm">
              <thead className="sticky top-0 bg-gray-50 border-b border-gray-200 z-10">
                <tr>
                  <th className="px-4 py-2.5 text-left text-[10px] font-semibold text-gray-400 uppercase tracking-wide">Поставщик / Наименование</th>
                  <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-gray-400 uppercase tracking-wide w-28">Бренд</th>
                  <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-gray-400 uppercase tracking-wide w-36">Артикул</th>
                  <th className="px-3 py-2.5 text-center text-[10px] font-semibold text-gray-400 uppercase tracking-wide w-20">Наличие</th>
                  <th className="px-3 py-2.5 text-right text-[10px] font-semibold text-gray-400 uppercase tracking-wide w-28">Цена</th>
                  <th className="px-3 py-2.5 w-24"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {offers.map((offer) => {
                  const inStock = (offer.in_stock || 0) > 0;
                  return (
                    <tr
                      key={offer.id}
                      className={`transition-colors ${inStock ? 'hover:bg-emerald-50/40' : 'opacity-60 hover:bg-gray-50'}`}
                    >
                      <td className="px-4 py-3">
                        <div className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide">{offer.supplier_name}</div>
                        <div className="font-medium text-gray-900">{offer.name}</div>
                      </td>
                      <td className="px-3 py-3 text-sm text-gray-600">{offer.brand || '—'}</td>
                      <td className="px-3 py-3 font-mono text-xs text-gray-600">{offer.articul || offer.oem || offer.code || '—'}</td>
                      <td className="px-3 py-3 text-center">
                        {inStock ? (
                          <span className="text-emerald-600 font-bold text-sm">{offer.in_stock}</span>
                        ) : (
                          <span className="text-gray-300 text-xs">нет</span>
                        )}
                      </td>
                      <td className="px-3 py-3 text-right">
                        <span className="font-bold text-gray-900">
                          {offer.client_price?.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ₸
                        </span>
                      </td>
                      <td className="px-3 py-3">
                        <Button
                          size="sm"
                          className="h-7 px-3 text-xs"
                          disabled={!inStock}
                          onClick={() => {
                            onAddToCart(offer.id, offer.packing_rate || 1);
                            onClose();
                          }}
                        >
                          <ShoppingCart className="w-3 h-3 mr-1" />
                          В корзину
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
